import "./App.css";
import { CartProvider } from "./context/CartContext";
import Main from "./Main";
import "antd/dist/reset.css";

function App() {
  return (
    <div>
      <CartProvider>
        <Main />
      </CartProvider>
    </div>
  );
}

export default App;
